import SearchOffIcon from "@mui/icons-material/SearchOff";

function NoResultFoundSidebar(props: any) {
  const { size, text } = props;
  return (
    <div className={`${size ? size : "p-12"}  text-center`}>
      <div className="text-primary text-center">
        <SearchOffIcon sx={{ width: "70px", height: "40px" }} />
      </div>
      <h3 className="mt-4"> {text ? text : "No Results Found!"}</h3>
    </div>
  );
}

export default NoResultFoundSidebar;
